import CollectionImage from '@/presentation/components/elements/CollectionImage';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import VaultIcon from '@/presentation/components/elements/VaultIcon';
import { useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Address } from 'viem';
import { UsingFormFields } from './types';

const UsingForm = ({
  size = 'normal',
  control,
  using,
  collection,
  collectionName,
  symbol,
  vaultId,
  icon,
}: {
  size: 'normal' | 'compact';
  control: Control<any, any>;
  using?: UsingFormFields['using'];
  collection: Address;
  collectionName: string;
  symbol: string;
  vaultId?: string;
  icon?: string;
}) => {
  const [showUsing, setShowUsing] = useState(false);
  return (
    <Controller
      name="using"
      control={control}
      render={({ field: { onChange } }) => {
        return (
          <div
            className={`relative border border-gray-300 ${
              showUsing ? 'rounded-t-md' : 'rounded-md'
            } grid`}
          >
            <button
              className={`rounded-md ${
                size === 'compact' ? 'py-1.5 px-4' : 'p-6'
              } flex items-center hover:bg-gray-100`}
              type="button"
              onClick={() => setShowUsing((x) => !x)}
            >
              {using === 'nft' ? (
                <CollectionImage
                  collection={collection}
                  className={`${
                    size === 'compact' ? 'w-5 h-5' : 'w-8 h-8'
                  } mr-2 flex-none flex`}
                />
              ) : vaultId != null ? (
                <VaultIcon
                  vaultId={vaultId}
                  className={`${
                    size === 'compact' ? 'w-5 h-5' : 'w-8 h-8'
                  } mr-2 flex-none flex`}
                />
              ) : icon ? (
                <img
                  src={icon}
                  alt={symbol}
                  className={`${
                    size === 'compact' ? 'w-5 h-5' : 'w-8 h-8'
                  } mr-2 flex-none flex`}
                />
              ) : (
                <span className="bg-gray-400 rounded-full w-8 h-8 mr-2 flex-none" />
              )}
              <span className="uppercase font-bold text-sm">
                {using === 'nft' ? collectionName : symbol}
              </span>
              <span className="ml-auto px-3 py-0.5 rounded-xl bg-gray-100 border border-gray-400 text-xs text-gray-500 font-normal">
                {using === 'nft' ? 'NFT' : 'ERC20'}
              </span>
              <span className="ml-2">
                <Icon
                  name={Icons.CHEVRON_DOWN}
                  size={size == 'compact' ? 20 : 24}
                  className={`${
                    showUsing ? 'rotate-180' : ''
                  } transform transition-transform`}
                />
              </span>
            </button>
            {showUsing && (
              <div className="absolute top-full -left-px -right-px bg-gray-50 border border-gray-300 rounded-b-md">
                {(['vtoken', 'nft'] as const).map((key) => (
                  <button
                    key={key}
                    type="button"
                    className="hover:bg-gray-100 py-2 px-6 text-left w-full flex justify-between items-center font-medium"
                    onClick={() => {
                      onChange(key);
                      setShowUsing(false);
                    }}
                  >
                    {key === 'nft' ? collectionName : symbol}
                    <span className="px-3 py-0.5 rounded-xl bg-gray-100 border border-gray-400 text-xs text-gray-500 font-normal">
                      {key === 'nft' ? 'NFT' : 'ERC20'}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      }}
    />
  );
};

export default UsingForm;
